import styled from 'styled-components';

export const StyledVirtualPageWrapper = styled.div`
  position: absolute;
  top: 0;
`;
